import React, { useEffect, useState } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
} from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import { UploadIcon } from "lucide-react";
import CustomTextField from "../../components/FormElements/CustomTextField";
import OutlinedButton from "../../components/FormElements/Buttons/OutlinedButton";
import ContainedButton from "../../components/FormElements/Buttons/ContainedButton";
import { Upload } from "antd";
import AxiosInstance from "../../services/networkServices";
import ActionFilter from "../../components/ActionFilter";
import { limitChar } from "../../utils/common";
import AddEditRap from "./AddEditRap";
import CommonPagination from "../../components/Table/CommonPagination";
import dayjs from "dayjs";
import AddWords from "./AddWords";
import { setLoading, showToast } from "../../store/slices/common";
import { useDispatch } from "react-redux";
import AddEditBattle from "./AddEditBattle";
import ConfirmDeleteModal from "../ManageBadge/ConfirmDeleteModal";
import ViewBattle from "./ViewBattle";
import ViewRap from "./ViewRap";
import PageLayout from "../../components/PageLayout";
import RapAvailabilityCard from "./RapAvailabilityCard";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "90vh",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "24px",
  },
  dialogContent: {
    maxWidth: "100%",
    padding: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
    },
  },
  tableContainer: {
    flex: 1,
    overflowY: "auto",
    maxHeight: "calc(100vh - 135px)",
    minHeight: "calc(100vh - 135px)",
    boxShadow: "none !important",
  },
  table: {
    minWidth: "100%",
    border: "1px solid rgba(224, 224, 224, 1)",
  },
  stickyHeader: {
    position: "sticky",
    top: "-1px",
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
  },
  actionsCell: {
    textAlign: "center",
  },
  actionsHeader: {
    textAlign: "center",
    fontWeight: "bold",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  searchField: {
    width: "300px",
    "& .MuiInputLabel-root": {
      color: "#142C5C", // Label color
      borderRadius: "15px",
      height: "50px",
    },
    "& .MuiInputBase-formControl": {
      padding: "15px",
      display: "flex",
      alignItems: "center",
      "& input": {
        padding: 0,
      },
      "& fieldset": {
        borderColor: "#142C5C", // Border color when not focused
      },
      "&:hover fieldset": {
        borderColor: "#142C5C", // Border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "#142C5C", // Border color when focused
      },
    },
  },
  input: {
    marginBottom: "0 !important",
    "& label.Mui-focused": {
      color: "#142C5C",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#142C5C",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      "& fieldset": {
        borderColor: "#142C5C",
      },
      "&:hover fieldset": {
        borderColor: "#142C5C",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#142C5C",
      },
    },
  },
  button: {
    backgroundColor: "#142C5C !important",
    color: "#fff !important",
    borderRadius: "6px !important",
    fontSize: "14px !important",
    height: "40px !important",
    borderColor: "#142C5C !important",
    "&:hover": {
      backgroundColor: "#0f2247 !important",
    },
  },
  actionsContainer: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
    paddingBottom: "10px",
  },
}));

const ManageWrap = () => {
  const classes = useStyles();
  const [selected, setSelected] = useState(1);
  const [formData, setFormData] = useState(null);
  const [openAddEditDialog, setAddEditDialog] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [dataList, setDataList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState("");
  // const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const [openViewModal, setOpenView] = useState(false);

  console.log(dataList, "dataList");

  // const [karaokes, setKaraokes] = useState([])
  // const [deleteId, setDeleteId] = useState('')
  // useEffect(() => {
  //     localStorage.removeItem('editKaraoke')
  //     fetchKaraokesHandler()
  // }, [])

  // const fetchKaraokesHandler = async () => {
  //     try {
  //         dispatch(setLoading(true))
  //         const res = await listKaraoke()
  //         setKaraokes(res.data.karaokes)
  //     } catch (err) {
  //         console.log(err)
  //     } finally {
  //         dispatch(setLoading(false))
  //     }
  // }

  // const openAddKaraokePage = () => {
  //     navigate(routePaths.uploadKaraoke)
  // }

  // const editHandler = (karaoke) => {
  //     localStorage.setItem('editKaraoke', JSON.stringify(karaoke))
  //     navigate(routePaths.uploadKaraoke)
  // }

  // const deleteHandler = async (karaoke) => {
  //     setDeleteId(karaoke?._id)
  // }

  // const confirmDeleteHandler = async () => {
  //     try {
  //         dispatch(setLoading(true))
  //         await deleteKaraoke(deleteId)
  //         await fetchKaraokesHandler()
  //         setDeleteId('')
  //     } catch (err) {
  //         console.log(err)
  //     } finally {
  //         dispatch(setLoading(false))
  //     }
  // }

  // const cancelDeleteHandler = () => {
  //     setDeleteId('')
  // }
  const buttonStyles = {
    padding: {
      xs: "6px",
      sm: "6px 16px",
      md: "6px 16px",
      lg: "6px 16px",
      xl: "6px 16px",
    },
    backgroundColor: "#142C5C",
    color: "#fff",
    borderColor: "#0f2247",
    "&:hover": {
      backgroundColor: "#0f2247 !important",
    },
    borderRadius: "6px",
    fontSize: {
      xs: "12px",
      sm: "13px",
      md: "13px",
      lg: "14px",
      xl: "14px",
    },
    height: {
      xs: "35px",
      sm: "40px",
      md: "40px",
      lg: "40px",
      xl: "40px",
    },
  };

  useEffect(() => {
    fetchList();
  }, [page, selected]);
  const fetchList = async (currPage) => {
    try {
      dispatch(setLoading(true));
      const type =
        selected === 1 ? "WORD" : selected === 2 ? "AUDIO" : "BATTLE";
      setLoading(true);
      const response = await AxiosInstance.get(
        `/rap?page=${page + 1}&limit=${15}&type=${type}`
      );
      if (response.data.status) {
        setDataList(response.data.data.list);
        setTotalCount(response.data.data.resultCount);
      } else {
        console.error("Failed to fetch categories:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleViewRap = (idx) => {
    const editableItem = dataList[idx];
    setSelectedItem(editableItem);
    setOpenView("rap");
  };
  const handleViewBattle = (idx) => {
    const editableItem = dataList[idx];
    setSelectedItem(editableItem);
    setOpenView("battle");
  };
  const handleEditItem = (idx) => {
    const editableItem = dataList[idx];
    setSelectedItem(editableItem);
    setAddEditDialog("rap");
  };

  const handleEditBattle = (idx) => {
    const editableItem = dataList[idx];
    setSelectedItem(editableItem);
    setAddEditDialog("battle");
  };

  const handleDeleteItem = (idx, type) => {
    const deletableItem = dataList[idx];
    setSelectedItem(deletableItem);
    setOpenDeleteModal(type);
  };

  const handleDeleteWord = async () => {
    try {
      dispatch(setLoading(true));
      const payload = {
        ids: selectedRows,
      };
      const resp = await AxiosInstance.post("/rap/remove-words", payload);
      setSelectedRows([]);
      setOpenDeleteModal("");
      fetchList();
      dispatch(showToast({ color: "success", msg: resp.data?.message }));
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleDeleteRapBattle = async () => {
    try {
      dispatch(setLoading(true));
      const payload = {
        id: selectedItem?._id,
      };
      if (openDeleteModal === "rap") {
        const resp = await AxiosInstance.post("/rap/remove-audio", payload);
        dispatch(showToast({ color: "success", msg: resp.data?.message }));
      } else if (openDeleteModal === "battle") {
        const resp = await AxiosInstance.post("/rap/remove", payload);
        dispatch(showToast({ color: "success", msg: resp.data?.message }));
      }
      setSelectedItem(null);
      setOpenDeleteModal("");
      fetchList();
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setLoading(false));
    }
  };

  // Function to handle selecting a row
  const handleSelectRow = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((rowId) => rowId !== id)
        : [...prevSelected, id]
    );
  };
  return (
    <PageLayout
      title="Rap"
      actions={
        <Box sx={{ display: "flex" }}>
          <Button
            sx={buttonStyles}
            variant="contained"
            onClick={() => {
              const type =
                selected === 1 ? "words" : selected === 2 ? "rap" : "battle";
              setAddEditDialog(type);
            }}
          >
            Add{" "}
            {selected === 1 ? "Words" : selected === 2 ? "Audio" : "Battle"}
          </Button>
          {selected === 1 && (
            <Button
              sx={{ ...buttonStyles, marginLeft: "10px" }}
              variant="contained"
              onClick={() => {
                setOpenDeleteModal("words");
              }}
              disabled={selectedRows?.length === 0}
            >
              Delete Words
            </Button>
          )}
        </Box>
      }
    >
      <>
        <Box display={"flex"}>
          <Button
            variant={selected === 1 ? "contained" : "outlined"}
            onClick={() => {
              setPage(0);
              setSelected(1);
            }}
          >
            Words
          </Button>
          <Button
            variant={selected === 2 ? "contained" : "outlined"}
            onClick={() => {
              setPage(0);
              setSelected(2);
            }}
            sx={{ marginLeft: "15px" }}
          >
            Audios
          </Button>
          <Button
            variant={selected === 3 ? "contained" : "outlined"}
            onClick={() => {
              setPage(0);
              setSelected(3);
            }}
            sx={{ marginLeft: "15px" }}
          >
            Battles
          </Button>
        </Box>
        <RapAvailabilityCard />
        <Box
          sx={{
            padding: "15px 15px 0 15px",
            borderRadius: "6px",
            boxShadow:
              "rgba(0, 0, 0, 0.05) 0 6px 24px 0, rgba(0, 0, 0, 0.08) 0 0 0 1px",
            marginTop: "20px",
          }}
        >
          {selected === 1 ? (
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.stickyHeader}>
                    {/* Add a new header cell for the checkbox */}
                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                        textAlign: "center",
                      }}
                      colSpan={1}
                    >
                      Select
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Word
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataList?.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={2} // Adjusted to account for the checkbox column
                        sx={{
                          textAlign: "center",
                          height: "calc(100vh - 270px)",
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "14px",
                            lg: "15px",
                            xl: "15px",
                          },
                          color: "#333",
                          padding: {
                            xs: "10px 5px",
                            sm: "10px",
                            md: "10px",
                            lg: "10px 15px",
                            xl: "10px 15px",
                          },
                        }}
                      >
                        No Words found
                      </TableCell>
                    </TableRow>
                  ) : (
                    dataList.map((item, index) => {
                      return (
                        <TableRow key={item?._id}>
                          {/* Checkbox Column */}
                          <TableCell
                            sx={{
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                              textAlign: "center",
                            }}
                          >
                            <Checkbox
                              checked={selectedRows.includes(item._id)} // You can maintain a selected rows state
                              onChange={() => handleSelectRow(item._id)}
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "14px",
                                lg: "15px",
                                xl: "15px",
                              },
                              color: "#333",
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                            }}
                          >
                            {item?.word}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          ) : selected === 2 ? (
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.stickyHeader}>
                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Thumbnail
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Title of the Rap
                    </TableCell>

                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                        textAlign: "center",
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {karaokes?.length === 0
                                ? ( */}
                  {dataList?.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        sx={{
                          textAlign: "center",
                          height: "calc(100vh - 270px)",
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "14px",
                            lg: "15px",
                            xl: "15px",
                          },
                          color: "#333",
                          padding: {
                            xs: "10px 5px",
                            sm: "10px",
                            md: "10px",
                            lg: "10px 15px",
                            xl: "10px 15px",
                          },
                        }}
                      >
                        No Raps found
                      </TableCell>
                    </TableRow>
                  ) : (
                    dataList.map((item, index) => {
                      return (
                        <TableRow key={item?._id}>
                          <TableCell
                            sx={{
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "14px",
                                lg: "15px",
                                xl: "15px",
                              },
                              color: "#333",
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                            }}
                          >
                            {item?.image ? (
                              <img
                                src={item?.image}
                                alt="Audio Logo"
                                width="25px"
                              />
                            ) : (
                              <span>No Thumbnail</span>
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "14px",
                                lg: "15px",
                                xl: "15px",
                              },
                              color: "#333",
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                            }}
                          >
                            {item.name || ""}
                          </TableCell>
                          <TableCell
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "14px",
                                lg: "15px",
                                xl: "15px",
                              },
                              color: "#333",
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                            }}
                          >
                            <ActionFilter
                              onView={handleViewRap}
                              onEdit={handleEditItem}
                              onDelete={(index) =>
                                handleDeleteItem(index, "rap")
                              }
                              index={index}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.stickyHeader}>
                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      logo
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Title
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Start Date
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      End Date
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "15px",
                          lg: "16px",
                          xl: "16px",
                        },
                        color: "#000",
                        fontWeight: 600,
                        padding: {
                          xs: "10px 5px",
                          sm: "15px 10px",
                          md: "15px 10px",
                          lg: "20px 15px",
                          xl: "20px 15px",
                        },
                        backgroundColor: "#e0e0e0",
                        textAlign: "center",
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {karaokes?.length === 0
                              ? ( */}
                  {dataList?.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        sx={{
                          textAlign: "center",
                          height: "calc(100vh - 270px)",
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "14px",
                            lg: "15px",
                            xl: "15px",
                          },
                          color: "#333",
                          padding: {
                            xs: "10px 5px",
                            sm: "10px",
                            md: "10px",
                            lg: "10px 15px",
                            xl: "10px 15px",
                          },
                        }}
                      >
                        No Raps found
                      </TableCell>
                    </TableRow>
                  ) : (
                    dataList.map((item, index) => {
                      return (
                        <TableRow key={item?._id}>
                          <TableCell
                            sx={{
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "14px",
                                lg: "15px",
                                xl: "15px",
                              },
                              color: "#333",
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                            }}
                          >
                            {item?.logo ? (
                              <img
                                src={item?.logo}
                                alt="Audio Logo"
                                width="25px"
                              />
                            ) : (
                              <span>No Thumbnail</span>
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "14px",
                                lg: "15px",
                                xl: "15px",
                              },
                              color: "#333",
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                            }}
                          >
                            {item.title || ""}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "14px",
                                lg: "15px",
                                xl: "15px",
                              },
                              color: "#333",
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                            }}
                          >
                            {dayjs(item?.startDate).format("DD MMM YYYY")}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "14px",
                                lg: "15px",
                                xl: "15px",
                              },
                              color: "#333",
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                            }}
                          >
                            {dayjs(item?.startDate).format("DD MMM YYYY")}
                          </TableCell>
                          <TableCell
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "14px",
                                lg: "15px",
                                xl: "15px",
                              },
                              color: "#333",
                              padding: {
                                xs: "10px 5px",
                                sm: "10px",
                                md: "10px",
                                lg: "10px 15px",
                                xl: "10px 15px",
                              },
                            }}
                          >
                            <ActionFilter
                              onView={handleViewBattle}
                              onEdit={handleEditBattle}
                              onDelete={(index) =>
                                handleDeleteItem(index, "battle")
                              }
                              index={index}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <CommonPagination
            count={totalCount}
            rowsPerPage={15}
            page={page}
            onPageChange={handlePageChange}
          />
        </Box>
        {openAddEditDialog === "rap" && (
          <AddEditRap
            selectedItem={{ ...selectedItem, uri: selectedItem?.audio }}
            openDialog={openAddEditDialog === "rap"}
            handleCloseDialog={() => {
              setAddEditDialog("");
              setSelectedItem(null);
            }}
            fetchList={fetchList}
          />
        )}
        {openAddEditDialog === "battle" && (
          <AddEditBattle
            selectedItem={selectedItem}
            openDialog={openAddEditDialog === "battle"}
            handleCloseDialog={() => {
              setAddEditDialog("");
              setSelectedItem(null);
            }}
            fetchList={fetchList}
          />
        )}
        <AddWords
          openDialog={openAddEditDialog === "words"}
          handleCloseDialog={() => {
            setAddEditDialog("");
            setSelectedItem(null);
          }}
          fetchList={fetchList}
        />
        {(openDeleteModal === "rap" || openDeleteModal === "battle") && (
          <ConfirmDeleteModal
            rap={openDeleteModal === "rap"}
            battle={openDeleteModal === "battle"}
            onAccept={handleDeleteRapBattle}
            onReject={() => setOpenDeleteModal("")}
          />
        )}
        {openDeleteModal === "words" && (
          <ConfirmDeleteModal
            words={true}
            onAccept={handleDeleteWord}
            onReject={() => setOpenDeleteModal("")}
          />
        )}
        {openViewModal === "battle" && (
          <ViewBattle
            openBattleView={openViewModal === "battle"}
            handleClose={() => {
              setSelectedItem(null);
              setOpenView("");
            }}
            selectedItem={selectedItem}
          />
        )}
        {openViewModal === "rap" && (
          <ViewRap
            openBattleView={openViewModal === "rap"}
            handleClose={() => {
              setSelectedItem(null);
              setOpenView("");
            }}
            selectedItem={selectedItem}
          />
        )}
        <ToastContainer />
        {/* {deleteId && <ConfirmDeleteModal onAccept={confirmDeleteHandler} onReject={cancelDeleteHandler} karaoke={true} />} */}
      </>
    </PageLayout>
  );
};

export default ManageWrap;
